module.exports = __webpack_public_path__ + "static/media/DGA-คู่มือการใช้โปรแกรมที่พัฒนาและปรับปรุง_ส่วนกลาง.3dcd148f.pdf";